/* eslint-disable */
/* eslint-disable import/no-unresolved */
import API_URLS from "src/config/API_URLS";
import { findKeysByValue } from "src/helpers/FormDetails/ProposalDetails/resources";
import axiosInstance from "src/utils/Axios/axiosInstance";
import StorageService from "src/utils/Storage/storageService";

export const UploadSignedMefForm = async ({ leadId, file }: { leadId: any; file?: any }) => {
  try {
    const formData = new FormData();
    formData.append("leadId", leadId);
    if (file) {
      formData.append("file", file);
    }
    const response = await axiosInstance.post(API_URLS.uploadSignedPdf, formData, {
      headers: {
        ...(file && { "Content-Type": "multipart/form-data" }),
        token: StorageService.getFromLocalStorage("verificationToken")
      }
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.error);
  }
};

export const uploadMultipleFiles = async ({
  leadId,
  files,
  fileNames
}: {
  leadId: any;
  files: any[];
  fileNames: Record<string, any>;
}) => {
  try {
    const formData = new FormData();
    formData.append("leadId", leadId);
    const fileNameCounter: Record<string, any> = {};
    files?.map((currentFile) => {
      const rawFileName = findKeysByValue(fileNames, currentFile?.documentType);
      const count = (fileNameCounter[rawFileName] || 0) + 1;
      fileNameCounter[rawFileName] = count;
      const finalFileName = count > 1 ? `${rawFileName}_${count - 1}` : rawFileName;
      const originalExtension = currentFile?.file?.name?.substring(
        currentFile?.file?.name?.lastIndexOf(".")
      );
      const newFileName = finalFileName + originalExtension;
      console.log("new file name", newFileName);
      formData.append("file", currentFile?.file, newFileName);
    });
    const response = await axiosInstance.post(API_URLS.uploadMultipleFiles, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.error);
  }
};

export const documentUploaded = async ({
  leadId,
  file,
  DocName
}: {
  leadId: any;
  file: any;
  DocName: string;
}) => {
  try {
    const formData = new FormData();
    formData.append("leadId", leadId);
    formData.append("file", file);
    formData.append("docName", DocName);
    const response = await axiosInstance.post(API_URLS.documentUpload, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        token: StorageService.getFromLocalStorage("verificationToken")
      }
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.error);
  }
};
